export class Model {
    // Uses Non-null assertion operator to avoid assigning a value to this.data again.
    // The generic type passed into this class will take care of correct type checking.
    data;
    constructor(rawData) {
        Object.defineProperty(this, 'data', {
            value: rawData,
            enumerable: false,
        });
    }
}
export class SerialisableModel extends Model {
    constructor(rawData) {
        super(rawData);
        const proto = Object.getPrototypeOf(this);
        Object.entries(Object.getOwnPropertyDescriptors(proto)).forEach(([key, descriptor]) => {
            if (descriptor && typeof descriptor.get === 'function') {
                try {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const value = this[key];
                    Object.defineProperty(this, key, {
                        value,
                        enumerable: true,
                    });
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(`Error calling getter ${key}`, error);
                }
            }
        });
    }
}
